<template>
    <div style="margin: 0 20px;">
		<div class="so">
			<el-input placeholder="输入订单号搜索" v-model="search">
			  <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
			</el-input>
		</div>
        <ex-table style="height: 78vh; margin-bottom: 10px;" height="760" :data="tableData" show-pagination :search-method="handleSearch" ref="table">
            <el-table-column prop="orderId" label="订单ID" width="180"></el-table-column>
			<el-table-column prop="image" label="商品图片" width="180" align="center">
				<template slot-scope="scope">
					<el-image style ="width:100px; height: 100px" :src="scope.row.image"
					:preview-src-list="[scope.row.image]"></el-image>
			　　	</template>
			</el-table-column>
            <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
			<el-table-column prop="price" label="付款金额" align="center"></el-table-column>
			<el-table-column prop="orderStatus" label="订单状态" align="center">
				<template slot-scope="scope">
					<el-tag type="warning" v-if="scope.row.orderStatus == 0">未支付</el-tag>
					<el-tag type="danger" v-else-if="scope.row.orderStatus == 1">等待发货</el-tag>
					<el-tag type="info" v-else-if="scope.row.orderStatus == 2">已取消</el-tag>
					<el-tag type="success" v-else>已发货</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="consignStatus" label="物流单号" align="center">
				<template slot-scope="scope">
					<el-tag type="info" v-if="scope.row.consignStatus == 0">无物流信息</el-tag>
					<el-tag type="success" v-if="scope.row.consignStatus == 1">{{scope.row.logisticId}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="address" label="收货信息" align="center">
				<template slot-scope="scope">
					<div>{{scope.row.contact}}</div>
					<div>{{scope.row.phone}}</div>
					<div>{{scope.row.address}}</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="mini" :disabled="scope.row.orderStatus == 1 ? false : true" type="primary" @click="sendGoods(scope.row)">发货</el-button>
				</template>
			</el-table-column>
        </ex-table>
        <el-button type="text" @click="$refs.table.setCurrentPage(1)"></el-button>
		
		<!-- 发货弹窗 -->
		<el-dialog title="发货" :visible.sync="dialogFormVisible">
			<div style="margin-left: 40px; margin-bottom: 10px;">
				<span>发货地址：</span>
				<span>{{selectOrder.contact + selectOrder.phone + selectOrder.address}}</span>
			</div>
			<div style="margin-left: 40px; margin-bottom: 30px;">
				<span>订单号：</span>
				<span>{{selectOrder.orderId}}</span>
			</div>
		  <el-form :model="sendOrderData">
			  <el-form-item label="快递公司" label-width="120px">
			    <el-select v-model="sendOrderData.shippingCode" placeholder="请选择快递公司">
			      <el-option
			            v-for="item in kuaiDiData"
			            :key="item.value"
			            :label="item.label"
			            :value="item.value">
			          </el-option>
			    </el-select>
			  </el-form-item>
		    <el-form-item label="快递单号" label-width="120px">
		      <el-input v-model="sendOrderData.logisticId" placeholder="请输入快递单号" autocomplete="off"></el-input>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogFormVisible = false">取 消</el-button>
		    <el-button type="primary" @click="sendKD">确 定</el-button>
		  </div>
		</el-dialog>
    </div>
</template>
<script>
import ExTable from "../components/table.js"
export default {
    components: { ExTable },
    data() {
        return {
			search:"",
			orderStatus: "",
            tableData: [],
			dialogFormVisible: false,
			kuaiDiData:[{
				label: '中通快递',
				value: 'ZTO'
			},{
				label: '邮政',
				value: 'EMS'
			},{
				label: '圆通快递',
				value: 'YTO'
			},{
				label: '申通快递',
				value: 'STO'
			},{
				label: '韵达快递',
				value: 'YD'
			},{
				label: '顺丰速运',
				value: 'SF'
			},{
				label: '极兔速递',
				value: 'JTSD'
			},{
				label: '京东快递',
				value: 'JD'
			}],
			selectOrder:{},			//选择的订单信息
			sendOrderData:{
				id:"",
				shippingCode:"",
				logisticId:""
			}
        }
    },
    methods: {
		//搜索
		searchClick(){
			this.fetchRemoteData(1, 10)
		},
        handleSearch(pagination, { currentPage, pageSize }) {
            this.fetchRemoteData(currentPage, pageSize)
        },
        fetchRemoteData(currentPage, pageSize) {
            //currentPage：当前页， pageSize: 每页最大条目数， 用于服务端分页
            //假设http请求数据，结果返回｛data_list: [...], total: ..｝
            //设置表格数据
           this.$axios.post("/api/order/backend/orderList", {
				page:currentPage,
				size:pageSize,
				orderId:this.search
           }).then(res => {
               if (res.data.code === "200" || res.data.code === 200) {
           		this.tableData = res.data.data.orderVolist
           		//设置分页总数
           		const pagination = this.$refs.table.pagination;
           		pagination.total = res.data.data.orderCount;
               } else {
           		// 提示失败信息
           		this.notifyError(res.data.msg);
               }
           }).catch(err => {
               return Promise.reject(err);
           });
        },
		//发货操作
		sendGoods(row){
			this.sendOrderData.id = row.id
			this.selectOrder = row
			this.dialogFormVisible = true
		},
		sendKD(){
			if(!this.sendOrderData.id || !this.sendOrderData.shippingCode || !this.sendOrderData.logisticId){
				return
			}
			this.$axios.post("/api/order/backend/shipments", this.sendOrderData).then(res => {
			    if (res.data.code === "200" || res.data.code === 200) {
					// 提示成功信息
					this.notifySucceed("发货成功");
					this.selectOrder.consignStatus = 1
					this.selectOrder.logisticId = this.sendOrderData.logisticId
					this.selectOrder.shippingCode = this.sendOrderData.shippingCode
			    } else {
					// 提示失败信息
					this.notifyError(res.data.msg);
			    }
				this.dialogFormVisible = false
			}).catch(err => {
				this.dialogFormVisible = false
			    return Promise.reject(err);
			});
		}
    },
    mounted() {
        this.$refs.table.fetchData();
    }
}
</script>

<style>
	.so {
	  margin-bottom: 10px;
	  width: 300px;
	  float: left;
	}
</style>